import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'ucMarkdown',
})
export class MarkdownPipe implements PipeTransform {
	transform(text: string): string {
		if (!text) return text;

		return text
			.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
			.replace(/^(\s*)-(\s*)([A-Z][^\n]*)/gm, '$1• $3<br/>');
	}
}
